module.exports = __webpack_public_path__ + "img/cover-aygaz-step-into-the-future.cecbdc0d.jpg";